import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Pagination, PagingResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {ClaimDocApprovalRequestContainerModel} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimDocApprovalRequestService extends BaseApiTemplateService<ClaimDocApprovalRequestContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'doc-approval-request-queues/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'doc-approval-request-queues/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'doc-approval-request-queues/backoffice-ep';
    this.httpClient = http;
  }

  public getByCriteriaLoginEntityEp(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<ClaimDocApprovalRequestContainerModel>> {
    const url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX
      + Core2Config.CLAIMS_PREFIX + 'doc-approval-request-queues/login-entity-ep';
    let epURL = Core2Config.DOMAIN_URL + url;
    if (visa.api_domain_url) {
      epURL = visa.api_domain_url + url;
    }
    const UrlByCriteria = epURL + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<ClaimDocApprovalRequestContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaLoginEntityPrimaryEp(
    pagination: Pagination,
    visa: ApiVisa,
    login_subject_guid: string,
  ): Observable<PagingResponseModel<ClaimDocApprovalRequestContainerModel>> {
    const url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX
      + Core2Config.CLAIMS_PREFIX + 'doc-approval-request-queues/login-entity-primary-ep' + `/${login_subject_guid}`;
    let epURL = Core2Config.DOMAIN_URL + url;
    if (visa.api_domain_url) {
      epURL = visa.api_domain_url + url;
    }
    return this.httpClient.get<PagingResponseModel<ClaimDocApprovalRequestContainerModel>>(
      epURL,
      this.getHttpHeader(visa)
    );
  }

  approveMultipleRequest(request: any[], visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'doc-approval-request-queues/processors/multiple/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'doc-approval-request-queues/processors/multiple/backoffice-ep';
    }
    return this.httpClient.put(url, request, this.getHttpHeader(visa));
  }

}


